import { render, staticRenderFns } from "./Ferier.vue?vue&type=template&id=595a4cb3&"
import script from "./Ferier.vue?vue&type=script&lang=js&"
export * from "./Ferier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports